import { PATH } from '../../constants/router'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseInput from '../../components/BasicComponent/BaseInput'
import AutomatedTrafficFineNotificationServiceCard from '../../components/FeaturesComponent/automatedTrafficFineNotificationServiceCard'
import AutomatedTrafficFineNotificationStep from '../../components/FeaturesComponent/automatedTrafficFineNotificationStep'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import useAutomatedTrafficFineNotificationServices, {
  SERVICE_TYPE_EMAIL,
  SERVICE_TYPE_SMS,
  SERVICE_TYPE_ZALO
} from '../../hooks/useAutomatedTrafficFineNotificationServices'
import { validatePhoneNumber } from '../../helper/common'
import { Modal } from 'antd'
import './index.scss'
import { IS_TAX_CDS_MODE, CURRENT_APP_MODE_CONFIG } from '../../constants/appMode'
import { useAppUserContext } from '../../context/AppUserContext'
import { useAppParamsContext } from '../../context/AppParamsContext'

export default function AutomatedTrafficFineNotificationServices() {
  const history = useHistory()
  const { userData } = useAppUserContext()
  const { usernamePrefix } = useAppParamsContext()

  const {
    onSelectService,
    servicesByCategory,
    selectedServices,
    isChoosed,
    selectedEmailService,
    isEmailValid,
    email,
    handleChangeEmailInput,
    errorEmail,
    selectedServiceEmailToCheck,
    handleCancelEmailModal,
    handleAgreeEmailModal,
    taxCdsFreelanceServices,
    taxCdsSmeServices,
    taxCdsOfficeServices
  } = useAutomatedTrafficFineNotificationServices()

  // Show phone input if not checked from param
  const showPhoneInput = CURRENT_APP_MODE_CONFIG.showPhoneInput && !userData?.phoneNumberFromSdk

  // State for phone input
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [isPhoneValid, setIsPhoneValid] = useState(!showPhoneInput)

  const zaloServices = servicesByCategory[SERVICE_TYPE_ZALO]
  const smsServices = servicesByCategory[SERVICE_TYPE_SMS]
  const emailServices = servicesByCategory[SERVICE_TYPE_EMAIL]
  const carServices = servicesByCategory['OTO']
  const motorbikeServices = servicesByCategory['XEMAY']

  // Handle phone input change
  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '')
    setPhoneNumber(value)

    const validation = validatePhoneNumber(value)
    setIsPhoneValid(validation.isValid)
    setPhoneError(validation.errorMessage)
  }

  const handleNextStep = () => {
  const selectedService = selectedServices[0]
  const vehicleType = selectedService?.vehicleType || undefined

  if (IS_TAX_CDS_MODE) {
    history.push(PATH.TAX_CDS_SMART_ASSISTANT_INFO, {
      services: selectedServices
    })
    return
  }

  let phoneToPass = userData?.phoneNumberFromSdk || ''
  let phoneWithPrefixToPass = userData?.phoneNumberWithUsernamePrefix || ''

  if (showPhoneInput && phoneNumber) {
    phoneToPass = phoneNumber
    const prefix = usernamePrefix || process.env.REACT_APP_USERNAME_PREFIX || 'TAMOVE'
    phoneWithPrefixToPass = `${prefix}${phoneNumber}`
  }

  history.push(`${PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES}`, {
    services: selectedServices,
    vehicleType,
    email,
    phoneNumberFromSdk: phoneToPass,
    phoneNumberWithUsernamePrefix: phoneWithPrefixToPass
  })
}
  return (
    <LayoutPartner headerTitle={CURRENT_APP_MODE_CONFIG.servicePageTitle} blendHeaderWithBody={false}>
      <div className="AutomatedTrafficFineNotificationServices">
        <AutomatedTrafficFineNotificationStep step={0} />
        <div className="AutomatedTrafficFineNotificationServices-purpose">
          {CURRENT_APP_MODE_CONFIG.servicePurposeText}
        </div>
        {/* Phần nhập số điện thoại - chỉ hiển thị khi chưa có số điện thoại từ trang introduce */}
        {/* Có thể sửa / nhập lại số điện thoại nếu không lấy được số điện thoại từ url trong trang introduce */}
        {showPhoneInput && (
          <div className="vehicle-info phone-input-section">
            <div className="vehicle-info__title">Nhập số điện thoại (Bắt buộc)</div>
            <BaseInput
              type="tel"
              value={phoneNumber}
              onChange={handlePhoneChange}
              placeholder="Nhập số điện thoại"
              inputMode="numeric"
              maxLength="11"
              error={phoneError}
            />
          </div>
        )}

        <div className="service-cards-wrapper">
          {IS_TAX_CDS_MODE ? (
            <>
              <AutomatedTrafficFineNotificationServiceCard
                title="Lao động tự do"
                list={taxCdsFreelanceServices}
                onSelectService={onSelectService}
              />
              <AutomatedTrafficFineNotificationServiceCard
                title="SME / Hộ kinh doanh"
                list={taxCdsSmeServices}
                onSelectService={onSelectService}
              />
              <AutomatedTrafficFineNotificationServiceCard
                title="Nhân viên văn phòng"
                list={taxCdsOfficeServices}
                onSelectService={onSelectService}
              />
            </>
          ) : (
            <>
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn Zalo" list={zaloServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn SMS" list={smsServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Tin nhắn Email" list={emailServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Ô tô" list={carServices} onSelectService={onSelectService} />
              <AutomatedTrafficFineNotificationServiceCard title="Xe máy" list={motorbikeServices} onSelectService={onSelectService} />
            </>
          )}
        </div>
        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          <BaseButton
            onClick={handleNextStep}
            disabled={IS_TAX_CDS_MODE ? !isChoosed : !isChoosed || !isPhoneValid || (selectedEmailService && !isEmailValid)}>
            Tiếp theo
          </BaseButton>
        </FixedBottom>
      </div>
      {CURRENT_APP_MODE_CONFIG.showEmailModal && (
  <Modal
        cancelText="Đóng"
        okText="Tiếp theo"
        onCancel={handleCancelEmailModal}
        onOk={handleAgreeEmailModal}
        title="Nhập email nhận thông báo"
        open={selectedServiceEmailToCheck}
        closable={false}
        okButtonProps={{
          style: {
            background: 'var(--brand-primary)!important',
            borderColor: 'var(--brand-primary)'
          }
        }}>
        <BaseInput
          className="my-4"
          value={email}
          onChange={handleChangeEmailInput}
          placeholder="info@gmail.com"
          error={errorEmail}
        />
      </Modal>
      )}
    </LayoutPartner>
  )
}
